/**
 * Gets the active element in the document or shadow root (if an element is provided, and it's in the shadow DOM).
 */
function getActiveElement(element, options) {
  if (element == null) {
    return document.activeElement;
  }
  const rootNode = element.getRootNode(options) ?? document;
  return rootNode.activeElement;
}

export { getActiveElement };
